import { createContext } from "use-context-selector"

import { createProvider } from "domain/createProvider"

const initState = {
  item: {
    data: {},
    error: null,
    isLoading: false,
  },
}

export const ApiKeyContext = createContext(initState)

export const ApiKeyProvider = createProvider(ApiKeyContext, initState)
